import { GET_ORDER_OF_CHILD } from "../../../enums/Request/request.types";

export const getOrderOfChildAction = (data) => {
    return {
        type: GET_ORDER_OF_CHILD,
        payload: data,
    };
};
